// extracted by mini-css-extract-plugin
export default {"hasBorderRadius":"Map_skill_hasBorderRadius__M4KSw","container":"Map_skill_container__ZDGVJ","containerImage":"Map_skill_containerImage__veclO"};